import { useDropzone } from 'react-dropzone';
import { Box } from '@mui/material';
import MediaDragDrop from './mediaDragDrop';


export default function FaceImageNonMatch({fileUpload, bannerShow}) {

    const onDrop = files => {
        fileUpload(files, 'nonMatchFaceImage');
    };

    const {getRootProps, getInputProps} = useDropzone({maxFiles:1, onDrop, 
        accept: {'image/jpeg': ['.jpg'],
                 'image/png': ['.png']
        }});

    return(
        <Box>
            <Box {...getRootProps()}>
                <input {...getInputProps()} disabled={bannerShow}/>
                <Box>
                    <MediaDragDrop />
                </Box>
            </Box>
        </Box>
    )
}